import { createRouter, createWebHistory } from 'vue-router'

import BlankLayout from '@/layouts/BlankLayout.vue'
import DefaultLayout from '@/layouts/DefaultLayout.vue'

import Login from '@/views/Login.vue'
import Dashboard from '@/views/Dashboard.vue'

import Shelters from '@/views/Shelter/Shelters.vue'
import ShelterCreate from '@/views/Shelter/ShelterCreate.vue'
import ShelterEdit from '@/views/Shelter/ShelterEdit.vue'

import Medicines from '@/views/Medicine/Medicines.vue'
import MedicineCountByDateView from '@/views/Medicine/MedicineCountByDateView.vue'
import MedicineCreate from '@/views/Medicine/MedicineCreate.vue';
import MedicineEdit from '@/views/Medicine/MedicineEdit.vue'
import MedicineInput from '@/views/Medicine/MedicineInput.vue'
import MedicineTransactions from '@/views/Medicine/MedicineTransactions.vue'

import Suppliers from '@/views/Supplier/Suppliers.vue'
import SupplierEdit from '@/views/Supplier/SupplierEdit.vue'
import SupplierCreate from '@/views/Supplier/SupplierCreate.vue'

import Users from '@/views/User/Users.vue'
import UserCreate from '@/views/User/UserCreate.vue'
import UserEdit from '@/views/User/UserEdit.vue'

import Warehousess from '@/views/Warehouse/Warehouse.vue'
import WarehouseCreate from '@/views/Warehouse/WarehouseCreate.vue'
import WarehouseEdit from '@/views/Warehouse/WarehouseEdit.vue'

import Animals from '@/views/Animal/Animals.vue'
import AnimalDetail from '@/views/Animal/AnimalDetail.vue'
import AnimalCreate from '@/views/Animal/AnimalCreate.vue'
import AnimalSpecies from '@/views/Animal/AnimalSpecies.vue'
import AnimalEdit from '@/views/Animal/AnimalEdit.vue'
import Profile from '@/views/Profile.vue'

const routes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        component: BlankLayout,
        children: [
            {
                path: '',
                component: Login,
                name: 'Login'
            }
        ]
    },
    {
        path: '/',
        component: DefaultLayout,
        children: [
            // Dashboard
            {
                path: 'dashboard',
                component: Dashboard,
                name: 'Dashboard'
            },
            // AnimalDetail
            {
                path: 'animal/detail/:id',
                name: 'AnimalDetail',
                component: AnimalDetail,
                meta: {
                    requiresAuth: true,
                    title: 'Hayvan Detayları'
                }
            },
            // AnimalAdd
            {
                path: 'animal/add',
                component: AnimalCreate,
                name: 'AnimalCreate',
                meta: {
                    requiresAuth: true,
                    title: 'Hayvan Ekle'
                }
            },
            // AnimalEdit
            {
                path: 'animal/edit/:id',
                name: 'AnimalEdit',
                component: AnimalEdit,
                meta: {
                    requiresAuth: true,
                    title: 'Hayvan Düzenle'
                }
            },
            // AnimalSpecies
            {
                path: 'animal/species',
                component: AnimalSpecies,
                name: 'AnimalSpecies',
                meta: {
                    requiresAuth: true,
                    title: 'Hayvan Türü',
                }
            },
            // AnimalList
            {
                path: 'animal/list/:page',
                component: Animals,
                name: 'Animals',
                meta: {
                    requiresAuth: true,
                    title: 'Patiler',
                    description: 'Hayvanlar hakkında bilgi alabileceğiniz sayfa',
                    keywords: 'hayvanlar, köpek, kedi, kuş'
                }
            },
            // ShelterList
            {
                path: 'shelter/list/:page',
                component: Shelters,
                name: 'Shelters',
                meta: {
                    requiresAuth: true,
                    title: 'Patiler',
                    description: 'Hayvanlar hakkında bilgi alabileceğiniz sayfa',
                    keywords: 'hayvanlar, köpek, kedi, kuş'
                }
            },
            // ShelterAdd
            {
                path: 'shelter/add',
                component: ShelterCreate,
                name: 'ShelterCreate',
                meta: {
                    requiresAuth: true,
                    title: 'Patiler',
                    description: 'Hayvanlar hakkında bilgi alabileceğiniz sayfa',
                    keywords: 'hayvanlar, köpek, kedi, kuş'
                }
            },
            // ShelterEdit
            {
                path: 'shelter/edit/:id',
                name: 'ShelterEdit',
                component: ShelterEdit,
                meta: {
                    requiresAuth: true,
                    title: 'Hayvan Düzenle'
                }
            },
            // WarehouseList
            {
                path: 'warehouse/list/:page',
                component: Warehousess,
                name: 'Warehousess',
                meta: {
                    requiresAuth: true,
                    title: 'Patiler',
                    description: 'Hayvanlar hakkında bilgi alabileceğiniz sayfa',
                    keywords: 'hayvanlar, köpek, kedi, kuş'
                }
            },
            // WarehouseAdd
            {
                path: 'warehouse/add',
                component: WarehouseCreate,
                name: 'WarehouseCreate',
                meta: {
                    requiresAuth: true,
                    title: 'Patiler',
                    description: 'Hayvanlar hakkında bilgi alabileceğiniz sayfa',
                    keywords: 'hayvanlar, köpek, kedi, kuş'
                }
            },
            // WarehouseEdit
            {
                path: 'warehouse/edit/:id',
                name: 'WarehouseEdit',
                component: WarehouseEdit,
                meta: {
                    requiresAuth: true,
                    title: 'Hayvan Düzenle'
                }
            },
            // MedicineCountsByDateList
            {
                path: 'medicine/list/by_date/:page/:medicine',
                component: MedicineCountByDateView,
                name: 'MedicineCountByDateView',
                meta: {
                    requiresAuth: true,
                    title: 'Patiler',
                    description: 'Hayvanlar hakkında bilgi alabileceğiniz sayfa',
                    keywords: 'hayvanlar, köpek, kedi, kuş'
                }
            },
            // MedicineList
            {
                path: 'medicine/list/:page',
                component: Medicines,
                name: 'Medicines',
                meta: {
                    requiresAuth: true,
                    title: 'Patiler',
                    description: 'Hayvanlar hakkında bilgi alabileceğiniz sayfa',
                    keywords: 'hayvanlar, köpek, kedi, kuş'
                }
            },
            // MedicineAdd
            {
                path: 'medicine/add',
                component: MedicineCreate,
                name: 'MedicineCreate',
                meta: {
                    requiresAuth: true,
                    title: 'Patiler',
                    description: 'Hayvanlar hakkında bilgi alabileceğiniz sayfa',
                    keywords: 'hayvanlar, köpek, kedi, kuş'
                }
            },
            // MedicineEdit
            {
                path: 'medicine/edit/:id',
                name: 'MedicineEdit',
                component: MedicineEdit,
                meta: {
                    requiresAuth: true,
                    title: 'Hayvan Düzenle'
                }
            },
            // MedicineTransaction
            {
                path: 'medicine/input/',
                name: 'MedicineInput',
                component: MedicineInput,
                meta: {
                    requiresAuth: true,
                    title: 'Hayvan Düzenle'
                }
            },
            // MedicineTransactionList
            {
                path: 'medicine_transaction/list/:page',
                name: 'MedicineTransactions',
                component: MedicineTransactions,
                meta: {
                    requiresAuth: true,
                    title: 'Hayvan Düzenle'
                }
            },
            // SupplierList
            {
                path: 'supplier/list/:page',
                component: Suppliers,
                name: 'Suppliers',
                meta: {
                    requiresAuth: true,
                    title: 'Patiler',
                    description: 'Hayvanlar hakkında bilgi alabileceğiniz sayfa',
                    keywords: 'hayvanlar, köpek, kedi, kuş'
                }
            },
            // SupplierEdit
            {
                path: 'supplier/edit/:id',
                name: 'SupplierEdit',
                component: SupplierEdit,
                meta: {
                    requiresAuth: true,
                    title: 'Hayvan Düzenle'
                }
            },
            // SupplierAdd
            {
                path: 'supplier/add',
                component: SupplierCreate,
                name: 'SupplierCreate',
                meta: {
                    requiresAuth: true,
                    title: 'Patiler',
                    description: 'Hayvanlar hakkında bilgi alabileceğiniz sayfa',
                    keywords: 'hayvanlar, köpek, kedi, kuş'
                }
            },
            // UserList
            {
                path: 'user/list/:page',
                component: Users,
                name: 'Users',
                meta: {
                    requiresAuth: true,
                    title: 'Patiler',
                    description: 'Hayvanlar hakkında bilgi alabileceğiniz sayfa',
                    keywords: 'hayvanlar, köpek, kedi, kuş'
                }
            },
            // UserAdd
            {
                path: 'user/add',
                component: UserCreate,
                name: 'UserCreate',
                meta: {
                    requiresAuth: true,
                    title: 'Patiler',
                    description: 'Hayvanlar hakkında bilgi alabileceğiniz sayfa',
                    keywords: 'hayvanlar, köpek, kedi, kuş'
                }
            },
            // UserEdit
            {
                path: 'user/edit/:id',
                name: 'UserEdit',
                component: UserEdit,
                meta: {
                    requiresAuth: true,
                    title: 'Hayvan Düzenle'
                }
            },

        ],
        meta: { requiresAuth: true }
    },
    {
        path: '/profile',
        component: Profile,
        meta: { requiresAuth: true }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    const isAuthenticated = !!localStorage.getItem('access')
    const { title, description, keywords } = to.meta

    if (to.meta.requiresAuth && !isAuthenticated) {
        next('/login')
    } else {
        if (title) document.title = title
        if (description) {
            const metaDescription = document.querySelector('meta[name="description"]')
            if (metaDescription) metaDescription.setAttribute('content', description)
        }
        if (keywords) {
            const metaKeywords = document.querySelector('meta[name="keywords"]')
            if (metaKeywords) metaKeywords.setAttribute('content', keywords)
        }

        next()
    }
})

export default router
